import { CardRulesEngine } from "@/web/routes/_protected/smb/-dashboard/-CardRulesEngine";
import { createSelectPropertyCompleted } from "@/web/routes/_protected/smb/-dashboard/-completedActions/SelectPropertyCompleted";

// One completed "Selected property" card per linked targetable property. The
// active selection flow now lives in ExplorePropertiesAction (multi-select);
// this rule stays property-scoped so each chosen property gets its own done
// card, regardless of how it was selected.
//
// Hidden for invited brands (paired with the hidden `explore-properties` card).
export const selectPropertyCompletedRule = CardRulesEngine.forEachCompletedRule({
  id: "select-property:done",
  forEach: CardRulesEngine.property,
  when: CardRulesEngine.and(
    CardRulesEngine.always,
    CardRulesEngine.not(CardRulesEngine.businessStoryIs("Invited")),
  ),
  build: (_, p) => createSelectPropertyCompleted({ property: p }),
});
